import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Block, LanguageSwitcher } from '@uncinc/react-drupal-core';
import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import AmsterdamundergroundLogo from '../../../assets/images/amsterdamunderground-logo.svg';
import { APP_OPTIONS, DEFAULT_LANGUAGE } from '../../../config/constants';
import { MenuSocial } from '../../../implementations';

import './style.scss';

export interface AmsterdamundergroundFooterProps {
  className?: string;
}

const AmsterdamundergroundFooter: React.FC<AmsterdamundergroundFooterProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();
  const currentLanguage = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));

  const classNames = c('Footer', 'AmsterdamundergroundFooter', className);

  return (
    <div className={classNames}>
      <Container>
        <div className="row">
          <div className="col-12">
            <div className="AmsterdamundergroundFooter__logo">
              <a href="/" aria-label="To home">
                <img src={AmsterdamundergroundLogo} alt="" />
              </a>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-5 col-xl-4">
            <div className="AmsterdamundergroundFooter__contact-block">
              <Block
                id={APP_OPTIONS.parameters.blockIdAmsterdamundergroundFooterContact}
                currentLanguage={currentLanguage}
              />
            </div>
          </div>

          <div className="col-12 col-md-4 offset-md-2 col-lg-2 offset-lg-0">
            <div className="AmsterdamundergroundFooter__social-menu">
              <h4>{t('components.amsterdamunderground_footer.social_menu_title')}</h4>
              <MenuSocial
                id="amsterdamunderground-social"
                showLabels
              />
            </div>
          </div>

          <div className="col-12 col-lg-4 offset-lg-1 offset-xl-2">
            <div className="AmsterdamundergroundFooter__language-switcher">
              <LanguageSwitcher hideActive={false} />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AmsterdamundergroundFooter;
